<template>
  <div class="app-layout__wrap">
    <MenuIcon @click="toggleCollapse" class="app-layout__sidenav-collapse-btn"/>
    <el-menu
      data-test="navbar"
      class="app-layout__sidenav"
      :class="{ 'app-layout__sidenav--visible': !isCollapse }">
      <el-menu-item
        @click="toggleCollapse"
        :index="'collapse'"
        :key="'collapse'">
        <MenuIcon />
      </el-menu-item>
      <div v-if="$store.getters['permissions/currentUserHasPermission']('ownShopUsers_read')">
        <el-menu-item
          v-for="item in managerOrAdminItems"
          @click="pushRoute({ name: item.routeName })"
          :index="item.routePath"
          :key="item.key"
          :class="{ 'is-active': isRouteActive(item.routeName) }"
          :data-test="item.dataTest">
          <i :class="item.iconClass"></i>
          <span>{{ $t(item.i18n) }}</span>
        </el-menu-item>
      </div>
      <el-menu-item
        v-for="item in menuItems"
        @click="pushRoute({ name: item.routeName })"
        :index="item.routePath"
        :key="item.key"
        :class="{ 'is-active': isRouteActive(item.routeName) }"
        :data-test="item.dataTest">
        <i :class="item.iconClass"></i>
        <span>{{ $t(item.i18n) }}</span>
      </el-menu-item>
    </el-menu>
    <div class="app-layout__view">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import MenuIcon from 'vue-material-design-icons/Menu.vue';

export default {
  components: {
    MenuIcon,
  },
  data() {
    return {
      collapse: !this.$mq.above(768),
      managerOrAdminItems: [
      ],
      menuItems: [
        {
          i18n: 'mainNav.newReceptionMenuItem',
          routeName: 'NewReception',
          key: '6',
          iconClass: 'el-icon-plus',
          dataTest: 'navbar__new-reception-link',
        },
        {
          i18n: 'mainNav.logoutMenuItem',
          routeName: 'Logout',
          key: '5',
          iconClass: 'el-icon-switch-button',
          dataTest: 'navbar__logout-link',
        },
      ],
    };
  },
  computed: {
    isCollapse() {
      return this.collapse;
    },
    currentUserRole() {
      return this.$store.getters['auth/currentUserProfile'].role;
    },
  },
  methods: {
    toggleCollapse() {
      this.collapse = !this.collapse;
    },
    isRouteActive(name) {
      return name === this.$route.name;
    },
    pushRoute(route) {
      if (route.name !== this.$route.name) {
        this.$router.push(route);
      }
    },
  },
};
</script>

<style lang="stylus">

$navbar-width = 64px;

.app-layout__wrap {
  background: #edf1f8;
  display: flex;
  min-height: 100vh;
  flex-direction: row;
  min-height: 100vh;
}

.app-layout__sidenav-collapse-btn {
  position: fixed;
  top: 20px;
  left: 20px;
  color: #fff;
  font-size: 2rem;
}

.app-layout__sidenav {
  width: $navbar-width;
  min-height: 100%;
  min-height: 100vh;
  display: none;
}
.app-layout__sidenav--visible {
  display: block;
}
.app-layout__sidenav:not(.el-menu--collapse) {
  width: 200px;
}

.app-layout__view {
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
